import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  class: "box-icon"
}
const _hoisted_2 = { class: "box-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "check-box",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["box", { active: _ctx.modelValue }])
    }, [
      (_ctx.modelValue)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[1] || (_cache[1] = [
            _createElementVNode("path", {
              d: "M10.6154 0.826904L4.26926 7.17306L1.38464 4.28844",
              stroke: "white",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, -1)
          ]))]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}